import styles from './Button.module.scss';
import type { Size, Variant } from './interfaces';

export const VARIANT: Record<Variant, Variant> = {
  primary: 'primary',
  primaryOutlined: 'primaryOutlined',
  secondary: 'secondary',
  brand: 'brand',
  outlined: 'outlined',
  shadowS: 'shadowS',
  shadowXS: 'shadowXS',
  specialWhite: 'specialWhite',
};

export const SIZE: Record<Size, Size> = {
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
};

export const VariantMap = new Map<Variant, string | undefined>([
  [VARIANT.primary, styles.primary],
  [VARIANT.primaryOutlined, styles.primaryOutlined],
  [VARIANT.secondary, styles.secondary],
  [VARIANT.brand, styles.brand],
  [VARIANT.outlined, styles.outlined],
  [VARIANT.shadowS, styles.shadowS],
  [VARIANT.shadowXS, styles.shadowXS],
  [VARIANT.specialWhite, styles.specialWhite],
]);

export const SizeMap = new Map([
  [SIZE.XS, styles.sizeXS],
  [SIZE.S, styles.sizeS],
  [SIZE.M, styles.sizeM],
  [SIZE.L, styles.sizeL],
  [SIZE.XL, styles.sizeXL],
]);

export const IconSizeMap = new Map([
  [SIZE.XS, 16],
  [SIZE.S, 16],
  [SIZE.M, 16],
  [SIZE.L, 16],
  [SIZE.XL, 24],
]);
